"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLUGGY_JS_VERSION = void 0;
// Project versions
// Needs to be updated manually since in client-side, we don't have access to the package.json file.
exports.PLUGGY_JS_VERSION = '0.17.0';
